import axios from "axios";
import state from "../store";

const baseURL = state.getters.mainAppURL + "area_restaurant_delivery_fee";

const getAreaDeliveryFeeDetails = (areaId) => axios.get( baseURL + "/" + areaId);
const updateAreaDeliveryFeeOfARestaurant = (params) => axios.post(baseURL, params);
const deleteAreaDeliveryFeeOfARestaurant = (id) => axios.delete(baseURL + "/" + id);

export {
    getAreaDeliveryFeeDetails,
    updateAreaDeliveryFeeOfARestaurant,
    deleteAreaDeliveryFeeOfARestaurant,
}